import {
  Component,
  ChangeDetectionStrategy,
} from '@angular/core';
import { fromEvent, Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { map, pairwise, distinctUntilChanged } from 'rxjs/operators';
import { CoreState } from 'src/app/state/_state.interfaces';
import { getUserInfo, getShowMenu, getShowCart } from 'src/app/state/_state.selectors';
import { LogoutSessions } from 'src/app/state/session.actions';
import { OpenSideNav, Navigation, MoveHome } from 'src/app/state/nav.actions';

/**
 * ナビバー(アプリバー)コンポーネント
 */
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavbarComponent {
  /** メニュー項目 */
  menuItems$: Observable<{label: string; menuItems: {label: string; path?: string}[]}[]>;
  /** メニューの表示 */
  showMenu$: Observable<boolean>;
  /** カートの表示 */
  showCart$: Observable<boolean>;

  /** スクロールの状態(hiddenNav: ナビバーの表示状態, elevation: ナビバーに影をつけるか?) */
  public isScrolling$: Observable<{hiddenNav: boolean; elevation: boolean}>;

  /** カートに入っている商品数 */
  cartItemCount$: Observable<number>;

  /**
   * コンストラクタ
   */
  constructor(
    private session: Store<CoreState>
  ) {
    this.menuItems$ = this.session.select(getUserInfo).pipe(map(userInfo => userInfo ? userInfo.menu : []));
    this.showMenu$ = this.session.select(getShowMenu);
    this.showCart$ = this.session.select(getShowCart);
    // スクロールイベントからObservableストリームを生成
    this.isScrolling$ = fromEvent(window, 'scroll').pipe(
      map(() => window.scrollY),
      pairwise(),
      map(values => {
        const prev = values[0];
        const cur = values[1];
        return {
          elevation: cur > 0,    // スクロールありなら影をつける
          hiddenNav: prev < cur && cur > 56     // ナビバーの高さ以上にスクロースしたらナビバーを隠す
        };
      }),
      distinctUntilChanged((prev, cur) => prev.elevation === cur.elevation && prev.hiddenNav === cur.hiddenNav)
    );
  }

  /**
   * サイドナビを開く
   */
  public openSidenav() {
    this.session.dispatch(new OpenSideNav());
  }

  /**
   * ナビゲーション
   */
  public navigate(path: string) {
    if (path) {
      this.session.dispatch(new Navigation({url: path}));
    }
  }

  /**
   * ホームへ
   */
  public home() {
    this.session.dispatch(new MoveHome());
  }

  /**
   * ログアウト
   */
  public logout() {
    this.session.dispatch(new LogoutSessions());
  }
}
